import React, { Component } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import contactsStore from '../store/contactsStore';

@observer
class ContactsPage extends Component {
  onSearch(e) {
    contactsStore.search(e.target.value);
  }
  render() {
    return (
      <div>
        <input
          type="search"
          className="form-control filter-text"
          placeholder="🔍Zoeken..."
          onChange={this.onSearch}
          value={contactsStore.filterText}
        />
        <div className="list-group">
          {contactsStore.contactsList.map(c => (
            <Link
              key={c.subNr}
              className="list-group-item contact-list-item"
              to={`/cm1/${c.subNr}`}
            >
              <h4>{c.acctName}</h4>
              {c.mainCont ? <div>{c.mainCont}</div> : null}
              {c.k1PpName ? <div>{c.k1PpName}</div> : null}
              {c.city}
              <span
                className={classnames('badge', {
                  deb: c.debShow,
                  cred: c.credShow
                })}
              >
                {c.debShow ? 'D' : ''}
                {c.credShow ? 'C' : ''}
              </span>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

export default ContactsPage;



// WEBPACK FOOTER //
// ./src/contacts/ContactsPage.js